import React, { useEffect, useState , useRef } from 'react';
import { useSelector, useDispatch  } from "react-redux";
import dynamic from "next/dynamic";
import Script from "next/script";
import Button, {BUTTON_OPERATION, BUTTON_WIDTH} from "@/bit/components/components.button";
import { RECAPTCHA_KEY } from "@gcloud-npm/utils.c2c";
import { actions as modalActions } from "@/bit/reducers/reducers.modals-reducer";
import { validateAnyPhone, validateEmail, validateRequired, docNumberValidation } from "@gcloud-npm/utils.validators";
import getDeviceKindDependsOnViewPort from "@gcloud-npm/utils.common.get-device-kind-depends-on-viewport";
import getUrlParams from "@gcloud-npm/utils.common.get-url-params";
import Text, {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_DISPLAY,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_SIZE,
} from "@/bit/components/components.text";
import { sendToRetargeting, sendTaggingInfo, conversePeopleMapIntoString, createDataObjet } from "./utils";
import Icon from "@/bit/components/components.icon-glyph";

const TYPE_QUESTIONS = {
  PERSONAS: 'personasHogar',
  RADIO: 'radio',
  CONSENTIMIENTO:'consentimiento',
  CHECK: 'check',
  INPUT: 'input',
  SELECT: 'select',
}

let Consents = null;

const FormAyudanosAConocerte = (props) => {
    const [data, setData] = useState(props.default);
    const [screen, setScreen] = useState(0);
    const [passedQuestions, setPassedQuestions] = useState(0);
    const [recaptchaReady, setRecaptchaReady] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const [pageError, setPageError] = useState(false);
    const [household, setHousehold] = useState([
        { id: 0, label: 'Yo', gender: '', age: '' },
        { id: 1, label: 'Persona 1', gender: '', age: '' },
        { id: 2, label: 'Persona 2', gender: '', age: '' },
        { id: 3, label: 'Persona 3', gender: '', age: '' },
        { id: 4, label: 'Persona 4', gender: '', age: '' },
        { id: 5, label: 'Persona 5', gender: '', age: '' },
        { id: 6, label: 'Persona 6', gender: '', age: '' },
    ]);
    const { context } = useSelector(
      (state) => state.main
    );
    const { questionMap , questions, idForm, idFormRetargeting } = props;
    const dispatch = useDispatch();

    useEffect(() => {
      sendTaggingInfo(
        {
          funnelStepName: 'inicio',
          funnel_flow_detail: idForm
        },
        'print-success',
        'profiling_form'
      );
    }, []);
    
    const initRef = useRef(null);

    const handleClickModalConsents = () => {
      const device = getDeviceKindDependsOnViewPort();
      const MODAL_PROPS = {
        contentPosition:
          device !== "MOBILE" ? "center--center" : "center--bottom",
        opacityLayoutColor: "black05",
        inSceneEffect: "fadeInBottom",
        outSceneEffect: "fadeOutBottom",
        closeByClickingOutside: true,
        scrollAllowed: false,
      };
      Consents = dynamic(() => import("./consents"));
      dispatch(
        modalActions.addModal({
          id: "consents",
          type: "MODAL",
          elementProps: {},
          Element2Show: Consents,
          modalProps: MODAL_PROPS,
        })
      );
    };

    const handleChange = (idQuestion, id, field, value) => {
      const newMap = household.map(person =>
        person.id === id ? { ...person, [field]: value } : person
      );

      validateMapPeople(idQuestion, newMap);

      setHousehold(newMap);
    };

    const handleClear = (idQuestion) => {
        setHousehold(household.map(person => ({ ...person, gender: '', age: '' })));
        setData((prevData) => ({
          ...prevData,
          [idQuestion]:  {value: '', valid: false, error : ''},
        }));
    };

    const getDependenciesValues = ({key, value}) => {
      let res = [];
      let auxRes = [];
      questions[key].values.forEach(question => {
        if(question.value !== value) {
          if(question.nextQuestions) {
            question.nextQuestions.forEach(element => {
              if(res.indexOf(element) == -1 ) {
                res.push(element);
              }
            })
          }
        } else {
          if(question.nextQuestions) {
            auxRes = question.nextQuestions;
          }
        }
      })

      res = res.filter(elemento => !auxRes.includes(elemento));

      return res;
    };

    const handleClick = ({key, value}) => {
      const dependenciesValue = getDependenciesValues({key, value});
      if(dependenciesValue.length === 0) {
        setData((prevData) => ({
          ...prevData,
          [key]: {value: value, valid: true, error : ''}
        }));
      } else {
        var obj = dependenciesValue.reduce((acc, key) => {
          acc[key] = {value: '', valid: props.default[key].valid, error: ''};
          return acc;
        }, {});
        setData((prevData) => ({
          ...prevData,
          [key]:  {value: value, valid: true, error : ''},
          ...obj
        }));
      }
    };

    const handleSelect = (element) => {
      const dependenciesValue = getDependenciesValues({key:  element.target.name, value:  element.target.value});
      if(dependenciesValue.length === 0) { 
        setData((prevData) => ({
          ...prevData,  
          [ element.target.name]: {value:  element.target.value, valid: true, error : ''}
        }));
      } else {
        var obj = dependenciesValue.reduce((acc, key) => {
          acc[key] = {value: '', valid: props.default[key].valid, error: ''};
          return acc;
        }, {});
        setData((prevData) => ({
          ...prevData,
          [ element.target.name]:  {value:  element.target.value, valid: true, error : ''},
          ...obj
        }));
      }
    }

    const handleClickCheckBox = ({key, value}) => {
      const dependenciesValue = getDependenciesValues({key, value});
      const valuesChecked = [...document.getElementsByName(key)]?.filter((value) => value.checked)?.map(element => element.value)?.join(', ');
      
      if(dependenciesValue.length === 0) {
        setData((prevData) => ({
          ...prevData,
          [key]: {value: valuesChecked, valid: valuesChecked !== '' ? true : false, error : ''}
        }));
      } else {
        var obj = dependenciesValue.reduce((acc, key) => {
          acc[key] = {value: '', valid: props.default[key].valid, error: ''};
          return acc;
        }, {});
        setData((prevData) => ({
          ...prevData,
          [key]:  {value: valuesChecked, valid: valuesChecked !== '' ? true : false, error : ''},
          ...obj
        }));
      }
    };

    const handleClickConsents = ({key, value}) => {
      const dependenciesValue = getDependenciesValues({key, value});
      
      if(dependenciesValue.length === 0) {
        setData((prevData) => ({
          ...prevData,
          [key]: {value: prevData[key].value === '' ? value : '', valid: prevData[key].required ? !prevData[key].valid : true, error : ''}
        }));
      } else {
        var obj = dependenciesValue.reduce((acc, key) => {
          acc[key] = {value: '', valid: props.default[key].valid, error: ''};
          return acc;
        }, {});
        setData((prevData) => ({
          ...prevData,
          [key]:  {value: prevData[key].value === '' ? value : '', valid: !prevData[key].valid, error : ''},
          ...obj
        }));
      }
    };

    const handleInput = (props) => {
      const question = questions[props.target.name];
      const validation = validateInput(question.validation, props.target.value, question.required);
      setData((prevData) => ({
        ...prevData,
        [props.target.name]: {value: props.target.value, valid: validation.validated, error: validation.errorMsg}
      }));
    }

    const validateInput = (type, value, required) => {
      let validation;
      switch (type) {
        case 'notBlank':
          if(required) {
            validation = validateRequired(value);
          } else {
            validation = { validated: true, errorMessage: ''};
          }
          break;
        case 'phone':
          validation = validateAnyPhone(value, {required});
           break;
        case 'email':
          validation = validateEmail(value, {required});
          break;
        case 'dni':
          validation = docNumberValidation(value, {required, allowDocTypes: ['DNI']});
          break;
      }
      return validation;
    }

    const validateMapPeople = (idQuestion, valueMap) => {
      const valuesIncompletes = valueMap.filter(value => ((value.gender === ''  && value.age !== '') || (value.gender !== ''  && value.age === '')));
      const selfValue = valueMap[0];
      if(selfValue.age === '' || selfValue.gender === '') {
        setData((prevData) => ({
          ...prevData,
          [idQuestion]:  {value: valueMap, valid: false, error : 'Rellena los datos referidos a ti'},
        }));
      } else if (valuesIncompletes.length > 0) {
        setData((prevData) => ({
          ...prevData,
          [idQuestion]:  {value: valueMap, valid: false, error : 'Los datos de alguna persona estan incompletos'},
        }));
      } else {
        const validMap = conversePeopleMapIntoString(valueMap);
        setData((prevData) => ({
          ...prevData,
          [idQuestion]:  {value: validMap, valid: true, error : ''},
        }));
      }
    }

    const getRecurrentQuestions = (valuesInMap, accumulativeQuestions) => {
      let allAditionalQuestions = [];
      valuesInMap.forEach(element => {
        const additionalQuestions = questions[element]?.values?.filter(elementFilter => elementFilter.value === data[element].value)?.[0]?.nextQuestions;
        if(additionalQuestions) {
          allAditionalQuestions = allAditionalQuestions.concat(additionalQuestions);
          accumulativeQuestions = accumulativeQuestions.concat(additionalQuestions);
        }
      })
      if(allAditionalQuestions.length == 0) {
        return accumulativeQuestions;
      } else {
        return getRecurrentQuestions(allAditionalQuestions, accumulativeQuestions)
      }
    }

    const validatePage = () => {
      const valuesInMap = questionMap[screen];
      const allValuesInScreen = getRecurrentQuestions(valuesInMap, valuesInMap);
      const valuesInvalid = allValuesInScreen.filter(element => data[element]?.valid === false);
      if(valuesInvalid.length > 0) {
        const obj = valuesInvalid.reduce((acc, key) => {
          acc[key] = {value: data[key].value, valid: data[key].valid, error:  data[key].error || 'Por favor, rellena este campo'};
          return acc;
        }, {});
        setPageError(true);
        setData((prevData) => ({
          ...prevData,
          ...obj,
        }));
      } else {
        setPageError(false);
        if((screen + 1) === questionMap.length) {
          setWaiting(true);
          const newData = createDataObjet(data)
          sendToRetargeting(context, newData, idFormRetargeting)
          .then((value) => {
            sendTaggingInfo(
              {
                funnelStepName: 'fin',
                funnel_flow_detail: idForm
              },
              'print-success',
              'profiling_form'
            );
            setScreen('ok');
            setWaiting(false);
          })
          .catch((error) => {
            sendTaggingInfo(
              {
                funnelStepName: 'error',
                funnel_flow_detail: idForm
              },
              'print-success',
              'profiling_form'
            );
            setScreen('ko');
            setWaiting(false);
          });
        } else {
          initRef.current.scrollIntoView({ behavior: 'smooth' });
          setPassedQuestions((prevData) => (prevData + questionMap[screen].length));
          setScreen((prevData) => (prevData + 1))
        } 
      } 
    }

    const backScreen = () => {
      setPassedQuestions((prevData) => (prevData - questionMap[screen - 1].length));
      setScreen((prevData) => (prevData - 1))
    }

    const printPregunta = (idQuestion, numberQuestion) => {
      const info = questions[idQuestion];
      switch(info.typeQuestion) {
        case TYPE_QUESTIONS.PERSONAS:
          return printPersonasHogar(info, idQuestion, numberQuestion);
        case TYPE_QUESTIONS.RADIO:
          return printPreguntaRadio(info,idQuestion, numberQuestion);
        case TYPE_QUESTIONS.CONSENTIMIENTO:
          return printPreguntaConsents(info,idQuestion, numberQuestion);
        case TYPE_QUESTIONS.CHECK:
          return printPreguntaCheck(info,idQuestion, numberQuestion);
        case TYPE_QUESTIONS.INPUT:
          return printPreguntaInput(info, idQuestion, numberQuestion);
        case TYPE_QUESTIONS.SELECT:
          return printPreguntaSelect(info, idQuestion, numberQuestion);
      }
    }

    const printTitleText = (question) => {
      if(!questions[question]?.titleText) {
        return null;
      }
      return (<div>
        <Text
          text={questions[question].titleText}
          size={TEXT_SIZE.T6}
          kind={TEXT_KIND.SPAN}
          color={TEXT_COLOR.BLUE_DARK}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />
        <style jsx>{`
          div {
              margin-top: 16px;
            }
        `}</style></div>)
    }

    const printScreenQuestion = (screen) => {
      return (<div>
        {screen === 0 && (
          printIntro()
        )}
        {screen !== 0 && (
          <a className="backLink" onClick={backScreen}>Volver</a>
        )}
        {questionMap[screen].map((element, key) => <>{printTitleText(element)}{printPregunta(element, passedQuestions+key+1)}</>)}
        {pageError && (<div className="pageError">
          <Text
            text="Revisa los campos marcados en rojo"
            size={TEXT_SIZE.CAPTION}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.RED}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
          />
        </div>)}
        <div className="wrapper-button">
          <Button
            disabled={screen !== questionMap.length ? false : !recaptchaReady}
            operation={
              waiting ? BUTTON_OPERATION.LOADING : BUTTON_OPERATION.NO
            }
            onClick={validatePage}
            label={(screen + 1) !== questionMap.length ? 'Continuar' : 'Enviar'}
            width={BUTTON_WIDTH.DOUBLE}
            buttonTypeHtml="submit"
            taggingInfo={{
              componentName: idForm,
              componentVariation: "all",
              componentContent: (screen + 1) !== questionMap.length ? 'Continuar' : 'Enviar',
            }}
          />
        </div>
        <div className="obligatorio">
        <Text
          text="* Campo obligatorio"
          size={TEXT_SIZE.CAPTION}
          kind={TEXT_KIND.SPAN}
          color={TEXT_COLOR.BLUE_DARK}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />
        </div>
        <style jsx>{`
          .pageError {
            padding-top: 2rem;
          }
          .wrapper-button {
            text-align: center;
            margin-top: 16px;
            button {
            transition: all 0.3s ease-in-out;
            padding: 0.75rem 1.25rem 0.75rem;
            width: auto;
            border: none;
            margin: 0.625rem 0 20px 0;
            text-align: center;
            font-family: Regular;
            font-size: 1.125rem;
            display: inline-block;
            background-color: #019DF4;
            color: white;
            border-radius: 4px;
          }
          }
          .backLink {
            color: #019DF4;
            font-size: 24px;
            cursor: pointer;
          }
          .obligatorio {
            padding-top: 16px;
          }
          `}
        </style>
      </div>);
    }

    const printPreguntaInput = (info, idQuestion, numberQuestion) => {
      return (<><div style={{"paddingTop": "20px"}}>
        { info.ask && (<Text
          text={`${numberQuestion} - ${info.ask} ${info.required ? " *": ""}`}
          size={TEXT_SIZE.T6}
          kind={TEXT_KIND.SPAN}
          color={TEXT_COLOR.BLUE_DARK}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />)}
        <div className="wrapperLabel">
          <input autoComplete="nope" id={idQuestion}  type="text" name={idQuestion} placeholder={info.placeholder} onBlur={handleInput}/>  
        </div>
        {data[idQuestion]?.error && (<Text
            text={data[idQuestion].error}
            size={TEXT_SIZE.CAPTION}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.RED}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
          />)}
      </div>
      <style jsx>{`
        input {
          border-bottom: solid 1px !important;
          padding-bottom: 2px;
          font-size: 18px;
          width: 100%;
        }
        .hidden {
          display: none;
        }
        .preguntaLabel {
          font-family: Regular;
          font-size: 18px;
          color: #50535A;
        }
        .wrapperLabel {
          min-height: 48px;
          display: flex;
          align-items: center;
        }
  `}</style>
      </>)
    }

    const printPreguntaCheck = (info, idQuestion, numberQuestion) => {
      return (<><div style={{"paddingTop": "20px"}}>
        { info.ask && (<Text
          text={`${numberQuestion} - ${info.ask} ${info.required ? " *": ""}`}
          size={TEXT_SIZE.T6}
          kind={TEXT_KIND.SPAN}
          color={TEXT_COLOR.BLUE_DARK}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />) }
        {info.values.map((answer, key) => (
          <div className="wrapperLabel">
            <input autoComplete="nope" id={idQuestion+key} checked={data[idQuestion]?.value?.indexOf(answer.value) > -1} className="hidden" type="checkbox" name={idQuestion} value={answer.value} onClick={() => {handleClickCheckBox({key: idQuestion, value: answer.value})}}/>
            <label for={idQuestion+key} className="preguntaLabel">
            <Text
              text={answer.label || answer.value}
              size={TEXT_SIZE.BODY1}
              kind={TEXT_KIND.SPAN}
              color={TEXT_COLOR.GREY5}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          </label>
          </div>
        ))}
        
      </div>
      {data[idQuestion]?.error && (<Text
            text={data[idQuestion].error}
            size={TEXT_SIZE.CAPTION}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.RED}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
          />)}
      {Array.from(new Set(info.values.filter(element => data[idQuestion].value.includes(element.value)).flatMap(element => element.nextQuestions || [])))?.map((element, key) => printPregunta(element, `${numberQuestion}.${key + 1}`))}
      {/* {info.values.filter(element => data[idQuestion].value.indexOf(element.value) > -1)?.[0]?.nextQuestions?.map((element, key) => (printPregunta(element, `${numberQuestion}.${key+1}`)))} */}
      <style jsx>{`
         /* Checkbox*/
        [type="checkbox"]+label {
          position: relative;
          height: auto !important;
          margin: 0.625rem 0;
          padding-left: 2.5rem;
        }

        [type="checkbox"]+label::before {
          content: "";
          position: absolute;
          left: 0.625rem;
          clear: both;
          width: 1.25rem;
          height: 1.25rem;
          top: 0.125rem;
          cursor: pointer;
        }

        [type="checkbox"]+label::after {
          content: "";
          position: absolute;
          clear: both;
          cursor: pointer;
        }

        [type="checkbox"]:not(:checked)+label:before {
          border: 0.0625rem solid #86888C;
        }

        [type="checkbox"]:checked+label:before {
          border: 0.0625rem solid #019DF4;
        }

        [type="checkbox"]:not(:checked)+label:after {
          opacity: 0;
        }

        [type="checkbox"]:checked+label:after {
          border-top: 0.125rem solid transparent;
          border-left: 0.125rem solid transparent;
          /*border-right: 0.125rem solid #5BC500;
            border-bottom: 0.125rem solid #5BC500; */
          border-right: 0.125rem solid #019DF4;
          border-bottom: 0.125rem solid #019DF4;
          height: 1.05rem;
          width: 0.5rem;
          top: 0.125rem;
          left: 0.6rem;
          -webkit-transform: rotateZ(37deg);
          transform: rotateZ(37deg);
          -webkit-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
        }
        .hidden {
          display: none;
        }
        .wrapperLabel {
          min-height: 48px;
          display: flex;
          align-items: center;
        }
  `}</style>
      </>)
    }

    const printConsent = ({info, idQuestion}) => {
      if(!info.ask) {
        return (<>
        <span onClick={() => {handleClickConsents({key: idQuestion, value: info.values[0].value})}}>
          Acepto el tratamiento de los datos aportados conforme al </span><a onClick={handleClickModalConsents}>aviso de privacidad</a><span onClick={() => {handleClickConsents({key: idQuestion, value: info.values[0].value})}}> *</span>
          <style jsx>{`
            a {
              color: #0086c3 !important
            }
          `}</style></>)
      } else {
        return (<><span onClick={() => {handleClickConsents({key: idQuestion, value: info.values[0].value})}}>{info.ask} {info.required ? " *": ""}</span></>)
      }
    }

    const printPreguntaConsents = (info, idQuestion, numberQuestion) => {
      return (<><div style={{"paddingTop": "24px"}}>
        <div className="wrapperLabel"><div className={`preguntaLabel ${data[idQuestion].value !== '' ? 'checked' : 'noChecked'}`}><span onClick={() => {handleClickConsents({key: idQuestion, value: info.values[0].value})}} className="checkElement"></span>{printConsent({info, idQuestion})}</div></div>
        
      </div>
      {data[idQuestion]?.error && (<Text
            text={data[idQuestion].error}
            size={TEXT_SIZE.CAPTION}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.RED}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
          />)}
      {info.values.filter(element => element.value === data[idQuestion].value)?.[0]?.nextQuestions?.map((element, key) => (printPregunta(element, `${numberQuestion}.${key+1}`)))}
      <style jsx>{`
         /* Checkbox*/
        .preguntaLabel {
          position: relative;
          height: auto !important;
          margin: 0.625rem 0;
          padding-left: 2.75rem;
        }

        .checkElement::before {
          content: "";
          position: absolute;
          left: 0.625rem;
          clear: both;
          width: 1.5rem;
          height: 1.5rem;
          cursor: pointer;
        }

        .checkElement::after {
          content: "";
          position: absolute;
          clear: both;
          cursor: pointer;
        }

        .noChecked .checkElement:before {
          border: 0.0625rem solid #86888C;
        }

        .checked .checkElement:before {
          border: 0.0625rem solid #019DF4;
        }

        .noChecked .checkElement:after {
          opacity: 0;
        }

        .checked .checkElement:after {
          border-top: 0.125rem solid transparent;
          border-left: 0.125rem solid transparent;
          /*border-right: 0.125rem solid #5BC500;
            border-bottom: 0.125rem solid #5BC500; */
          border-right: 0.125rem solid #019DF4;
          border-bottom: 0.125rem solid #019DF4;
          height: 1.0625rem;
          width: 0.5625rem;
          top: 0.125rem;
          left: 0.6875rem;
          -webkit-transform: rotateZ(37deg);
          transform: rotateZ(37deg);
          -webkit-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
        }
        .hidden {
          display: none;
        }
        .pregunta {
          font-family: Regular;
          font-size: 20px;
          color: #0B2739;
        }
        .preguntaLabel {
          font-family: Regular;
          font-size: 18px;
          color: #50535A;
          cursor: pointer;
        }
        .wrapperLabel {
          min-height: 48px;
          display: flex;
          align-items: center;
        }
  `}</style>
      </>)
    }

    const printPreguntaSelect = (info,idQuestion, numberQuestion) => {
      return (<><div style={{"paddingTop": "20px"}}>
        { info.ask && (<Text
          text={`${numberQuestion} - ${info.ask} ${info.required ? " *": ""}`}
          size={TEXT_SIZE.T6}
          kind={TEXT_KIND.SPAN}
          color={TEXT_COLOR.BLUE_DARK}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />) }
          <div className="wrapperLabel">
            <select id={idQuestion} name={idQuestion} onChange={handleSelect}>
            {data[idQuestion].value === '' && (<option value="">Seleccione una opción</option>)}
            {info.values.map((answer, key) => (
              <option value={answer.value}>{answer.value}</option>
            ))}
            </select>
          </div>
          {data[idQuestion]?.error && (<Text
            text={data[idQuestion].error}
            size={TEXT_SIZE.CAPTION}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.RED}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
          />)}
      </div>
      {info.values.filter(element => element.value === data[idQuestion].value)?.[0]?.nextQuestions?.map((element, key) => (printPregunta(element, `${numberQuestion}.${key+1}`)))}
      <style jsx>{`
        select {
          width: 100%;
          margin-top: 10px;
          border-top: none;
          border-right: none;
          border-left: none;
          background: #FAFAFA;
          border-bottom:solid 1px #767676;
          text-align: center;
          font-size: 18px;
          padding-bottom: 2px;
          option {
            font-size: 18px;
          }
        }
        .hidden {
          display: none;
        }
        .pregunta {
          font-family: Regular;
          font-size: 20px;
          color: #0B2739;
        }
        .preguntaLabel {
          font-family: Regular;
          font-size: 18px;
          color: #50535A;
        }
        .wrapperLabel {
          min-height: 48px;
          display: flex;
          align-items: center;
        }
  `}</style>
      </>)
    }

    const printPreguntaRadio = (info,idQuestion, numberQuestion) => {
      return (<><div style={{"paddingTop": "20px"}}>
        { info.ask && (<Text
          text={`${numberQuestion} - ${info.ask} ${info.required ? " *": ""}`}
          size={TEXT_SIZE.T6}
          kind={TEXT_KIND.SPAN}
          color={TEXT_COLOR.BLUE_DARK}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />) }
        {info.values.map((answer, key) => (
          <div className="wrapperLabel">
            <input autoComplete="nope" id={idQuestion+key} checked={data[idQuestion].value === answer.value} className="hidden" type="radio" name={idQuestion} value={answer.value} onClick={() => {handleClick({key: idQuestion, value: answer.value})}}/>
            <label for={idQuestion+key}className="preguntaLabel">
              <Text
                text={answer.label || answer.value}
                size={TEXT_SIZE.BODY1}
                kind={TEXT_KIND.SPAN}
                color={TEXT_COLOR.GREY5}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </label>
          </div>
        ))}
      </div>
      {data[idQuestion]?.error && (<Text
            text={data[idQuestion].error}
            size={TEXT_SIZE.CAPTION}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.RED}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
          />)}
      {info.values.filter(element => element.value === data[idQuestion].value)?.[0]?.nextQuestions?.map((element, key) => (printPregunta(element, `${numberQuestion}.${key+1}`)))}
      <style jsx>{`
        /*Radio*/
        [type="radio"]+label {
          position: relative;
          height: auto !important;
          padding-left: 2.5rem;
        }

        [type="radio"]+label::before {
          content: "";
          display: block;
          position: absolute;
          left: 0.625rem;
          clear: both;
          width: 1.25rem;
          height: 1.25rem;
          top: 0.1rem;
          border-radius: 50%;
          cursor: pointer;
        }

        [type="radio"]+label::after {
          content: "";
          position: absolute;
          clear: both;
          cursor: pointer;
        }

        [type="radio"]:not(:checked)+label:before {
          border: 0.0625rem solid #86888C;
        }

        [type="radio"]:checked+label:before {
          /* border: 0.0625rem solid #5BC500; */
          border: 0.0625rem solid #019DF4;
        }

        [type="radio"]:not(:checked)+label:after {
          opacity: 0;
        }

        [type="radio"]:checked+label:after {
          border-radius: 50%;
          height: 0.625rem;
          width: 0.625rem;
          top: 0.4rem;
          left: 0.95rem;
          -webkit-transition: .28s ease;
          transition: .28s ease;
          /* background: #5BC500; */
          background: #019DF4;
        }
        .hidden {
          display: none;
        }
        .pregunta {
          font-family: Regular;
          font-size: 20px;
          color: #0B2739;
        }
        .wrapperLabel {
          min-height: 48px;
          display: flex;
          align-items: center;
        }
  `}</style>
      </>)
    }

    const printPersonasHogar = (info, idQuestion, numberQuestion) => {
      return (<><div style={{"paddingTop": "20px"}}>
                { info.ask && (<Text
          text={`${numberQuestion} - ${info.ask} ${info.required ? " *": ""}`}
          size={TEXT_SIZE.T6}
          kind={TEXT_KIND.SPAN}
          color={TEXT_COLOR.BLUE_DARK}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />) }
                <div className="wrapperClear">
                <span
                    onClick={(e) => {handleClear(idQuestion)}}
                    className="clear-selection"
                >
                    Borrar selección
                </span>
                </div>
                {household.map(person => (
                    <div key={person.id} className="form-item">
                        <label>{person.label}</label>
                        <select
                            value={person.gender}
                            onChange={(e) => handleChange(idQuestion, person.id, 'gender', e.target.value)}
                        >
                            <option value="">Selecciona</option>
                            <option value="masculino">Masculino</option>
                            <option value="femenino">Femenino</option>
                            <option value="otro">Otro</option>
                        </select>
                        <input autoComplete="nope"
                            type="number"
                            placeholder="Edad"
                            value={person.age}
                            onChange={(e) => handleChange(idQuestion, person.id, 'age', e.target.value)}
                        />
                    </div>
                ))}
    </div>
    {data[idQuestion]?.error && (<Text
            text={data[idQuestion].error}
            size={TEXT_SIZE.CAPTION}
            kind={TEXT_KIND.SPAN}
            color={TEXT_COLOR.RED}
            fontType={TEXT_FONT_WEIGHT.LIGHT}
          />)}
    <style jsx>{`
      .wrapperClear {
        margin-top: 16px;
        margin-right: 16px;
        text-align: right;
        .clear-selection {
          color: #00A9E0;
          cursor: pointer;
          font-size: 16px;
        }
      }
      .hidden {
        display: none;
      }
      .pregunta {
        font-family: Regular;
        font-size: 20px;
        color: #0B2739;
      }
      .preguntaLabel {
        font-family: Regular;
        font-size: 18px;
        color: #50535A;
      }
      .wrapperLabel {
        min-height: 48px;
        display: flex;
        align-items: center;
      }
      .form-item {
        display: flex;
        max-width: 700px;
        margin-top: 18px;
      select, label, input {
        width: 28%;
        margin-right: 5%;
      }
      select {
        appearance: auto;
      }
      select, input {
        border-bottom: solid 1px !important;
      }
      }
`}</style>
    </>)
    }


    const printIntro = () => {
      return (<>
        <div className="wrapperTitle">
          <Text
            text="Ayúdanos a conocerte mejor"
            size={TEXT_SIZE.T1}
            kind={TEXT_KIND.HEADING}
            level={1}
            color={TEXT_COLOR.BLUE_DARK}
            fontType={TEXT_FONT_WEIGHT.BOLD}
          />
        </div>
        <div className="wrapperSubtitle">
          <Text
            text={props.welcomeMessage}
            size={TEXT_SIZE.T4}
            kind={TEXT_KIND.HEADING}
            level={2}
            color={TEXT_COLOR.BLUE_DARK}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
        </div>
          
            <style jsx>{`
              .wrapperSubtitle {
                padding: 1.5rem 0;
              }              
              `}</style>
      </>)
    }

    const onReadyRecaptcha = () => {
      setRecaptchaReady(true);
    };

    const printMessageCustom = () => {
      let params = getUrlParams({
        currentUrl: (context && context.contextURL) || window.location.href,
      });

      if(params.promo === "smartwifi") {
        return (<>
          <Text
            text="En los próximos días te enviaremos un Email / SMS para que puedas solicitar tu nuevo Router Smart WiFi 6."
            size={TEXT_SIZE.T3}
            kind={TEXT_KIND.PARAGRAPH}
            color={TEXT_COLOR.BLUE_DARK}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
      <style jsx>{`
        div {
          padding: 0.5rem 0;
        }
        `}</style>
      </>)
      }
      return null;
    }

    const printOkScreen = () => {
      return (
        <div className="information-ok">
          <div><Icon id="bola-ok" height={48} color="green" /></div>
          <div>
              <Text
                text="La información se ha enviado con éxito."
                size={TEXT_SIZE.T3}
                kind={TEXT_KIND.PARAGRAPH}
                color={TEXT_COLOR.BLUE_DARK}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </div>
          {printMessageCustom()}
          <div>
              <Text
                text="¡Muchas gracias!"
                size={TEXT_SIZE.T3}
                kind={TEXT_KIND.PARAGRAPH}
                color={TEXT_COLOR.BLUE_DARK}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
              />
            </div>
        <style jsx>{`
        .information-ok {
          font-size: 32px;
          text-align: center;
          font-family: Regular;
          min-height: 500px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          div {
            padding: 0.5rem 0;
          }
        }
        `}</style>
      </div>
      )
    }

    const printKoScreen = () => {
      return (
        <div className="information-ok">
          <div><Icon id="alerta-m" height={48} color="orange" /></div>
          <div>Ha ocurrido un error.</div>
          <div>Algo ha ido mal y no hemos podido recoger tus datos. Por favor, vuelve a intentarlo.</div>
        <style jsx>{`
        .information-ok {
          font-size: 32px;
          text-align: center;
          font-family: Regular;
          min-height: 500px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          div {
            padding: 0.5rem 0;
          }
        }
        `}</style>
      </div>
      )
    }

    return (
        <div ref={initRef} className={`encuestaAyudanosAConocerte container  ${waiting ? "no-pointer-event" : ""}`}>
          <Script
            src={`https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY}`}
            strategy="lazyOnload"
            onReady={onReadyRecaptcha}
          />
            <div className="form-section">
              {screen !== 'ok' && screen !== 'ko' && printScreenQuestion(screen)}
              {screen === 'ok' && (printOkScreen())}
              {screen === 'ko' && (printKoScreen())}
            </div>
            <style jsx>{`
              .encuestaAyudanosAConocerte {
                background-color: #FAFAFA;
                max-width:940px;
                padding: 2rem;
                :global(.error) {
                  color: #d23c31;
                  padding: 0.5rem;
                  font-size: 14px;
                }
              }
              .no-pointer-event {
                pointer-events: none;
              }
              `}</style>
        </div>
    );
};

export default FormAyudanosAConocerte;
